// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  version: '1.0.0-#130',
  apiUrl: 'https://apis.dev.auckland.ac.nz/rsc/v2/',
  auth: {
    cognitoAwsRegion: 'ap-southeast-2',
    cognitoClientId: '288c9m64gkcj22ivpo2torfbvc',
    cognitoUserPoolId: 'ap-southeast-2_gtuqqgIIq',
    cognitoDomain: 'uoapool-nonprod',
    redirectUri: 'https://rankscorecalculator.dev.auckland.ac.nz',
    logoutUri: 'https://rankscorecalculator.dev.auckland.ac.nz',

    scopes: 'openid profile https://auth.auckland.ac.nz/api-rank-score-calculator-v2:write',
    codeChallengeMethod: 'S256',
  },
  privateUrlKeyWords: {
    // default optional to false
    whoNeedBearerToken: [{ url: 'apis.dev.auckland.ac.nz', optional: true }],
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
